<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <div
        style="width: 50%; margin: auto; /* 完整水平居中 */ line-height: 26px"
      >
        <a-form-model-item
          label="房屋状态"
          :label-col="{ span: 24 }"
          :wrapper-col="{ span: 24 }"
          prop="houseStatus"
        >
          <div style="padding-left: 30px; /* 缩进，让内容视觉居中 */">
            <a-radio-group v-model="form.houseStatus" :disabled="!isEditable">
              <a-radio style="margin: 4px 0px" value="1"
                >本标的房屋租赁合同已到期，房屋尚在使用中，若招租后发生移交纠纷，由出租方负责解决</a-radio
              >
              <br />
              <a-radio style="margin: 4px 0px" value="2"
                >本标的房屋尚在租赁合同期内，到期后由出租方负责落实资产交付相关事项</a-radio
              >
              <br />
              <a-radio style="margin: 4px 0px" value="3"
                >本标的房屋物业状态为空置</a-radio
              >
              <br />
              <div class="radio-line">
                <a-radio style="margin: 4px 0px" value="99">
                  <span class="radio-inline-wrap">
                    <span>其他</span>
                    <span
                      ><a-form-model-item
                        v-if="form.houseStatus == 99"
                        prop="housingStatusOtherDesc"
                        class="inline-form-item"
                      >
                        <a-input
                          v-model="form.housingStatusOtherDesc"
                          :disabled="!isEditable"
                          class="inline-input"
                          placeholder="请输入其他房屋状态说明"
                        /> </a-form-model-item
                    ></span>
                  </span>
                </a-radio>
              </div>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="租赁面积" prop="leaseArea">
        <a-input
          v-model="form.leaseArea"
          placeholder="请输入租赁面积"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
    <a-col :span="12" v-if="form.houseStatus == 2">
      <a-form-model-item label="租赁期限届满时间" prop="leaseExpireTime">
        <a-date-picker
          style="width: 100%"
          v-model="form.leaseExpireTime"
          :disabled="!isEditable"
          placeholder="请选择租赁期限届满时间"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租赁用途" prop="leaseUseType">
        <a-checkbox-group
          v-model="form.leaseUseType"
          style="width: 100%"
          :disabled="!isEditable"
        >
          <a-row :gutter="[0, 12]">
            <a-col
              :span="3"
              v-for="item in dictionaries.leaseUseType"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24" v-if="form.leaseUseType.includes('16384')">
      <a-form-model-item label="其他租赁用途说明" prop="leaseUse">
        <a-input
          v-model="form.leaseUse"
          placeholder="请输入其他租赁用途说明"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
import { initLeaseUseType } from "@/api/shexgrp/InitDictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      fetching: {
        leaseUseType: false,
      },
      dictionaries: {
        leaseUseType: [],
      },
    };
  },
  mounted() {
    this.initLeaseUseTypeDictionaries();
  },
  methods: {
    // 通用加载租赁用途字典
    async loadLeaseUseTypeDictionaries(apiFn, errorMsg) {
      // 已有数据则不再请求
      if (this.dictionaries.leaseUseType.length > 0) return;

      // 防止重复请求
      if (this.fetching.leaseUseType) return;

      this.fetching.leaseUseType = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.dictionaries.leaseUseType = res.data || [];
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.leaseUseType = false;
      }
    },

    // 初始化租赁用途字典
    initLeaseUseTypeDictionaries() {
      return this.loadLeaseUseTypeDictionaries(
        initLeaseUseType,
        "租赁用途字典初始化失败"
      );
    },
  },
};
</script>

<style scoped>
/* 包住整句话 */
.radio-inline-wrap {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
/* form-item 行内显示 */
.inline-form-item {
  display: inline-flex !important;
  align-items: center;
  margin: 0 8px !important;
}

/* 输入框统一规格 */
.inline-input {
  width: 300px;
  min-width: 100px;
  max-width: 400px;
  margin-top: 10px;
}
</style>